import type { ReactNode } from "react";
import { BUILDER_STEPS as STEPS } from "./builderSteps";

/** Where the builder is: "Step 2 of 3", a bar per step, and the page's heading. */
export function StepHeader({ step }: { step: number }) {
  return (
    <s-stack gap="small-200">
      <s-text color="subdued">
        Step {step + 1} of {STEPS.length}: {STEPS[step]?.label}
      </s-text>
      <div style={{ display: "flex", gap: 4 }} aria-hidden="true">
        {STEPS.map((s, i) => (
          <div
            key={s.label}
            style={{
              flex: 1,
              height: 4,
              borderRadius: 2,
              background: i <= step ? "#303030" : "#e3e3e3",
            }}
          />
        ))}
      </div>
      <s-heading>{STEPS[step]?.title}</s-heading>
    </s-stack>
  );
}

/** One headline number of the estimate, with an optional control under it. */
export function Figure({
  label,
  value,
  hint,
  action,
}: {
  label: string;
  value: string;
  hint: string;
  action?: ReactNode;
}) {
  return (
    <s-stack gap="small-300">
      <s-text color="subdued">{label}</s-text>
      <s-heading>{value}</s-heading>
      <s-text color="subdued">{hint}</s-text>
      {action && <s-stack direction="inline">{action}</s-stack>}
    </s-stack>
  );
}

/** What still stops the page, shown once the merchant has pressed "Next" on it. */
export function Blockers({ lines }: { lines: string[] }) {
  if (lines.length === 0) return null;
  return (
    <s-banner tone="info" heading="Before you continue">
      <s-stack gap="small-300">
        {lines.map((line) => (
          <s-text key={line}>• {line}</s-text>
        ))}
      </s-stack>
    </s-banner>
  );
}
